export const environment = {
  production: false,
  name: 'dev',
  modulePk:'01HHMDTBQ27DZSPH31KTWB29JZ:module',
  moduleSk:'01HHMDTBQ2FF03KEJJQNGN2HQR:current',
  secretbKey: "47921864973276484792186497327648",
  accessControlAPI:'https://access-control-v6.mango-api-dev.com/v1',
};
